"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactCssThemr = require("react-css-themr");
var _RenderInBody;
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * Renders the children of this component inside of a <div> that it creates
 * at the top-level of the document body.
 *
 * TODO: Why does this component exist? What is its purpose? And for the love
 * TODO: of god, document the properties and event handling behaviors. ヽ(ಠ_ಠ)ノ
 */

var defaultProps = {
  orderedKeyDownHandler: false
};
var RenderInBody = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(RenderInBody, _React$Component);
  function RenderInBody(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, RenderInBody);
    _this = _callSuper(this, RenderInBody, [props]);
    _this.renderLayer = _this.renderLayer.bind((0, _assertThisInitialized2["default"])(_this));
    if (!RenderInBody.isHandlersActive && typeof document !== 'undefined') {
      document.body.addEventListener('keydown', RenderInBody.handleKeyDown);
      RenderInBody.isHandlersActive = true;
    }
    return _this;
  }

  /**
   * Creates the component div, wires the event handler to the body,
   * and renders the child elements in the div
   */
  (0, _createClass2["default"])(RenderInBody, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        onKeyDown = _this$props.onKeyDown,
        orderedKeyDownHandler = _this$props.orderedKeyDownHandler;
      this.node = document.createElement('div');
      this.node.tabIndex = -1;
      document.body.appendChild(this.node);
      if (onKeyDown) {
        if (orderedKeyDownHandler) {
          RenderInBody.handlers.push(onKeyDown);
        } else {
          document.body.addEventListener('keydown', onKeyDown);
        }
      }
      this.renderLayer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.renderLayer();
    }

    /**
     * Removes this component's div from the body and the virtual DOM
     * and also unregisters the keydown event handler.
     */
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props2 = this.props,
        onKeyDown = _this$props2.onKeyDown,
        orderedKeyDownHandler = _this$props2.orderedKeyDownHandler;
      _reactDom["default"].unmountComponentAtNode(this.node);
      document.body.removeChild(this.node);
      if (onKeyDown) {
        if (orderedKeyDownHandler) {
          RenderInBody.handlers.splice(RenderInBody.handlers.indexOf(onKeyDown), 1);
        } else {
          document.body.removeEventListener('keydown', onKeyDown);
        }
      }
    }

    /**
     * Returns `true` if the portal itself or any of its children is the active element.
     */
  }, {
    key: "hasActiveElement",
    value: function hasActiveElement() {
      // The check for this.node.contains(activeElement) is necessary to prevent IE11's
      // scrollbar from closing the menu in certain contexts.
      return this.node === document.activeElement || this.node.contains(document.activeElement);
    }

    /**
     * Renders the children of this component into the top-level div that
     * this component creates inside of the document's <body>.
     */
  }, {
    key: "renderLayer",
    value: function renderLayer() {
      var content = this.props.children;
      if (this.context && this.context.themr && this.context.themr.theme) {
        content = /*#__PURE__*/_react["default"].createElement(_reactCssThemr.ThemeProvider, {
          theme: this.context.themr.theme
        }, content);
      }
      if (!content) {
        throw new Error('No content provided to component');
      }
      _reactDom["default"].render(content, this.node);
    }
  }, {
    key: "render",
    value: function render() {
      return false;
    }
  }]);
  return RenderInBody;
}(_react["default"].Component);
_RenderInBody = RenderInBody;
(0, _defineProperty2["default"])(RenderInBody, "defaultProps", defaultProps);
// TODO: Is this necessary or even correct? this static handlers arrray smells
// TODO: like yesterday's socks.
(0, _defineProperty2["default"])(RenderInBody, "handlers", []);
/**
 * TODO: Make whomever did not document this feel our WRATH.
 */
(0, _defineProperty2["default"])(RenderInBody, "handleKeyDown", function (e) {
  var currentHandler = _RenderInBody.handlers[_RenderInBody.handlers.length - 1];
  if (currentHandler) {
    currentHandler(e);
  }
});
(0, _defineProperty2["default"])(RenderInBody, "isHandlersActive", false);
RenderInBody.contextTypes = {
  themr: _propTypes["default"].object
};
//# sourceMappingURL=index.js.map